import Col from "react-bootstrap/Col";
import IconSvg from "../../SharedComponents/IconSvg";
import Row from "react-bootstrap/Row";

const CusProLogo = ({ size, fill }) => {
  return (
    <Row>
      <Col xs={"auto"} className={"align-content-center"}>
        <IconSvg icon="cp-logo" height={size} width={size} fill={fill} />
      </Col>
      <Col
        xs={"auto"}
        className={`text-${Math.floor(size - size / 4)} lh-1  fw-medium ps-0 `}
        style={{ color: fill ? fill : "#274c77" }}
      >
        Cus-Pro
      </Col>
    </Row>
  );
};
export default CusProLogo;
